import * as Sentry from '@sentry/vue';
import { showToast } from '@inscribe/signal';
import { InscribeEventsLogger, INSCRIBE_EVENTS } from '@/events-logger';

/**
 * logMessage logs the message to Sentry for informational/debugging purposes
 *
 * @param {string} msg
 */
export function logMessage(msg) {
  if (!msg) {
    return;
  }
  Sentry.captureMessage(msg);
}

/**
 * logError logs the error to Sentry and includes the stack trace
 *
 * @param {Error} err - the Error object
 */
export function logError(err) {
  if (!err) {
    return;
  }
  Sentry.captureException(err);
}

/**
 * here we can have a centralised way to notify the user of global HTTP errors
 * @param {*} error
 */
let Error429NotifyTimeout = 0;
export function notifyErrorToUI(error) {
  /*
   * Handle 429 errors, possibly we could get this error from multiple calls, so we need to debounce it
   */
  if (error?.status === 429) {
    let timeoutTime = 5000;
    if (Error429NotifyTimeout) {
      clearTimeout(Error429NotifyTimeout);
    } else {
      timeoutTime = 0;
    }
    Error429NotifyTimeout = setTimeout(() => {
      showToast({
        title: 'Too many requests',
        text: 'You have exceeded the allowed number of requests. Please contact Inscribe to understand why this error has occurred or try again later.',
        isError: true,
      });
      InscribeEventsLogger.logEvent(
        INSCRIBE_EVENTS.TOO_MANY_REQUESTS_NOTIFIED,
        { axiosError: error },
      );
    }, timeoutTime);
  }
  // log 400 errors
  if (error?.status === 400) {
    InscribeEventsLogger.logEvent(INSCRIBE_EVENTS.HTTP_400_RESPONSE, {
      axiosError: error,
    });
  }
}
